import api from '../utils/api';

// Fetch all feedback records
export const getAllFeedback = async (headers) => {
  try {
    const response = await api.get('/api/feedback',  headers );
    return response.data;
  } catch (error) {
    console.error('Error fetching all feedback:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Fetch a specific feedback record by ID
export const getFeedbackById = async (id, headers) => {
  try {
    const response = await api.get(`/api/feedback/${id}`,  headers );
    return response.data;
  } catch (error) {
    console.error(`Error fetching feedback with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};

// Create a new feedback record
export const createFeedback = async (feedbackData, headers) => {
  try {
    const response = await api.post('/api/feedback', feedbackData,  headers );
    return response.data;
  } catch (error) {
    console.error('Error creating feedback:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Update an existing feedback record
export const updateFeedback = async (id, feedbackData, headers) => {
  try {
    const response = await api.put(`/api/feedback/${id}`, feedbackData,  headers );
    return response.data;
  } catch (error) {
    console.error(`Error updating feedback with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};

// Delete a feedback record
export const deleteFeedback = async (id, headers) => {
  try {
    const response = await api.delete(`/api/feedback/${id}`,  headers );
    return response.data;
  } catch (error) {
    console.error(`Error deleting feedback with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};
